import { Component, OnInit } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'formly-panel',
    template: `<div [className]="editMode?'':'disabled-text'" [innerHTML]="field.props.label"></div>`,
    standalone: true,
    imports: [FormlyModule]
})
export class PanelComponent extends FieldWrapper implements OnInit{


editMode: boolean

ngOnInit(): void {
    this.props.editMode$.subscribe(
        (val:boolean)=>this.editMode=val
    )
}

}
